const TAGS = {
    "ex"  : "Exogenous",
    "en"  : "Endogenous",
    "pm"  : "Process Mining",
    "dm"  : "Decision Mining",
    "phd" : "PhD",
    "qut" : "QUT",
    "res" : "Research",
    "cod" : "Coding",
    "pmd" : "Process Discovery",
    "pmc" : "Conformance Checking",
    "pme" : "Process Enhancement",
    "rwth" : "RWTH Aachen",
    "csys" : "Complex Systems",
    "au" : "Adelaide University"
}

export {
    TAGS
}